/* The native Shopify forms still own filtering, sorting, URLs and pagination.
   This enhancement only controls the desktop sidebar's presentation. */
(() => {
  if (window.PlainJaneCampaignLayout) return;
  window.PlainJaneCampaignLayout = true;
  const desktop = window.matchMedia('(min-width: 64rem)');
  const states = new Map();
  const compact = window.matchMedia('(max-width: 767px)');
  function initializeNotes(root = document) {
    root.querySelectorAll('[data-campaign-collection-notes]').forEach(notes => {
      if (notes.dataset.campaignNotesReady) return;
      notes.dataset.campaignNotesReady = 'true';
      notes.open = !compact.matches;
    });
  }
  function setOpen(grid, open) {
    const button = grid.querySelector('[data-campaign-filter-toggle]');
    const sidebar = grid.querySelector('.collection-grid__filters');
    if (!button || !sidebar) return;
    grid.classList.add('pj-filters-ready');
    grid.classList.toggle('pj-filters-open', open);
    button.setAttribute('aria-expanded', String(open));
    button.querySelector('[data-campaign-filter-label]').textContent = open ? 'Hide filters' : 'Filter';
    sidebar.inert = desktop.matches && !open;
    states.set(sidebar.id, open);
  }
  function initialize(root = document) {
    initializeNotes(root);
    root.querySelectorAll('.pj-campaign-grid.collection-grid--filters').forEach(grid => {
      const id = grid.querySelector('.collection-grid__filters')?.id;
      const defaultOpen = grid.dataset.campaignFiltersDefaultOpen === 'true';
      setOpen(grid, states.has(id) ? states.get(id) : defaultOpen);
    });
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-campaign-filter-toggle]');
    if (!button) return;
    setOpen(button.closest('.pj-campaign-grid'), button.getAttribute('aria-expanded') !== 'true');
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape' || !desktop.matches) return;
    const grid = event.target.closest('.pj-campaign-grid.pj-filters-open');
    if (!grid) return;
    setOpen(grid, false);
    grid.querySelector('[data-campaign-filter-toggle]').focus();
  });
  desktop.addEventListener('change', () => initialize());
  compact.addEventListener('change', () => {
    document.querySelectorAll('[data-campaign-collection-notes]').forEach(notes => { notes.open = !compact.matches; });
  });
  document.addEventListener('shopify:section:load', () => initialize());
  // The theme morphs existing grid elements during sort/filter updates, so
  // an attribute-only morph will not be seen by the child-list observer.
  document.addEventListener('section:content-updated', event => {
    if (event.target.matches('collection-section')) initialize();
  });
  initialize();
  /* Shopify replaces collection sections after an AJAX filter change. Watch
     child replacements only, not attributes or the entire document. */
  const main = document.getElementById('MainContent');
  if (main && main.querySelector('.pj-campaign-grid')) {
    new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 &&
          (node.matches('.pj-campaign-grid, collection-section, [data-campaign-filter-toggle]') || node.querySelector('.pj-campaign-grid, [data-campaign-filter-toggle]'))))) initialize();
    }).observe(main, { childList: true, subtree: true });
  }
})();
